export default __webpack_public_path__ + "static/media/08_mountain.fb15f0e3.JPG";